import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { datasourceEndpoints } from '@/api/endpoints';
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { LENGTH_XS } from '@/util/validation/constants';
import { createNameFieldSchema } from '@/util/validation/schema-builders';

interface CreateFolderProps {
  collectionId: string;
  onSubmit: (data: { name: string }) => void;
}

export const CreateFolder = ({ collectionId, onSubmit }: CreateFolderProps) => {
  const { t } = useTranslation();

  // Create schema with dynamic name validation
  const formSchema = yup.object({
    name: createNameFieldSchema({
      getEndpoint: (name) =>
        datasourceEndpoints.checkName(collectionId, name, { collection_id: collectionId }),
      max: LENGTH_XS,
    }),
  });

  type FormValues = yup.InferType<typeof formSchema>;
  const form = useForm<FormValues>({
    resolver: yupResolver<FormValues, unknown, FormValues>(formSchema),
    mode: 'onSubmit',
    defaultValues: { name: '' },
  });

  return (
    <div className="flex flex-col items-start justify-start gap-2 p-2">
      <p className="px-1 text-sm font-semibold">{t('collections.documents.create_folder')}</p>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-4">
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <Input
                    placeholder={t('collections.documents.folder_name')}
                    {...field}
                    onChange={(e) => {
                      field.onChange(e);
                      form.trigger('name');
                    }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button type="submit" size="sm" className="w-full">
            {t('common.create')}
          </Button>
        </form>
      </Form>
    </div>
  );
};
